<template>
  <div class="dropdown-footer__content">
    <Link :href="url" class="dropdown-footer___content-link" is-unstyled>
      {{ text }}
      <GradientIcon name="ArrowRight" />
    </Link>
  </div>
</template>

<script>
import Link from '@/components/common/Link/Link'
import GradientIcon from '@/components/common/GradientIcon/GradientIcon'

export default {
  components: {
    Link,
    GradientIcon
  },
  props: {
    text: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-footer {
  &__content {
    display: block;
    margin-top: $gap;
    padding-top: $gap;
    border-top: 1px solid #422965;
    background: linear-gradient(135deg, rgba(248, 121, 0, 1) 0%, rgba(254, 79, 69, 1) 50%, rgba(228, 25, 186, 1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    @include display-less(desktop) {
      border-top: 1px solid #dfdfdf;
    }
    &-link {
      display: flex;
      flex-direction: row;
      align-items: center;
      text-decoration: none;
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      gap: $gap * 0.5;
    }
  }
}
</style>
